module.exports = __webpack_public_path__ + "img/project-banner2.991e2487.jpg";